var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tag-horizontal_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.221 21H13.858C16.0854 21 17.1992 21 18.1289 20.4672C19.0586 19.9345 19.6488 18.958 20.8294 17.005L21.5102 15.8787C22.5034 14.2357 23 13.4142 23 12.5C23 11.5858 22.5034 10.7643 21.5102 9.12126L20.8294 7.99501C19.6488 6.04203 19.0586 5.06554 18.1289 4.53277C17.1992 4 16.0854 4 13.858 4H11.221C7.34561 4 5.40789 4 4.20394 5.2448C3 6.48959 3 8.49306 3 12.5C3 16.5069 3 18.5104 4.20394 19.7552C5.40789 21 7.3456 21 11.221 21Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 7.99609V17.001",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.ee41ea5c524514a57d1f97c3afc8ade5.svg";
export { ForwardRef as ReactComponent };